// src/components/About.jsx
import React from "react";
import styled from "styled-components";
import { Section as BaseSection, Card as BaseCard } from "./sharedStyles";

/* Dark themed section */
const Section = styled(BaseSection)`
  background: ${(p) =>
    p.theme.gradients?.bgSection ||
    `linear-gradient(180deg, ${p.theme.colors.bgDarker}, ${p.theme.colors.bgDark})`};
  color: ${(p) => p.theme.colors.text};
  padding: 50px 16px;
`;

/* Center heading */
const Heading = styled.h2`
  text-align: center;
  margin-bottom: 24px;
  font-size: 2rem;
  font-weight: 900;
  color: ${(p) => p.theme.colors.text};
`;

/* Single merged card */
const Card = styled(BaseCard)`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.03),
    rgba(255, 255, 255, 0.015)
  );
  padding: 28px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  max-width: 900px;
  margin: 0 auto;
`;

/* Typography */
const P = styled.p`
  color: ${(p) => p.theme.colors?.muted};
  line-height: 1.6;
  margin: 0 0 16px 0;
`;

const Sub = styled.h3`
  margin: 28px 0 12px 0;
  font-weight: 800;
  color: ${(p) => p.theme.colors.text};
`;

const List = styled.ul`
  color: ${(p) => p.theme.colors?.muted};
  margin-left: 20px;
  line-height: 1.6;

  li {
    margin-bottom: 8px;
  }
`;

const Label = styled.div`
  margin-top: 18px;
  font-weight: 700;
  color: ${(p) => p.theme.colors.text};
`;

const Value = styled.div`
  margin-top: 6px;
  color: ${(p) => p.theme.colors?.muted};
  line-height: 1.4;
`;

const HR = styled.hr`
  border: none;
  height: 1px;
  margin: 22px 0;
  background: rgba(255, 255, 255, 0.08);
`;

/* Component */
export default function About() {
  return (
    <Section id="about">
      <Heading>About Us</Heading>

      <Card>
        {/* INTRO */}
        <P>
          <strong>K Shyam G Management</strong> is a registered collections &
          recovery management agency operating across Uttar Pradesh and nearby
          regions. Established in <strong>2019</strong>, we work with retail
          banks, NBFCs and digital lenders. We specialise in compliant, ethical
          and data-backed collection strategies that give lenders measurable
          recovery while maintaining borrower dignity.
        </P>

        {/* WHO WE ARE */}
        <Sub>Who We Are</Sub>
        <P>
          We are a <strong>Proprietorship firm</strong> registered under GST in
          Uttar Pradesh. The agency maintains structured field operations,
          trained teams, transparent MIS reporting and a dedicated escalation &
          compliance desk.
        </P>

        {/* APPROACH */}
        <Sub>Our Collection Approach</Sub>
        <List>
          <li>Early, mid & late stage bucket strategies</li>
          <li>Trained field officers & tele-calling teams</li>
          <li>Local area expertise for faster resolutions</li>
          <li>Fully RBI-compliant communication practices</li>
          <li>Zero harassment policy & borrower dignity first</li>
          <li>Daily MIS, dashboards & escalation handling</li>
        </List>

        {/* WHY TRUST US */}
        <Sub>Why Partners Trust Us</Sub>
        <List>
          <li>Transparent reporting & measurable performance</li>
          <li>Reliable field coverage & trained workforce</li>
          <li>Strong compliance discipline</li>
          <li>Experience across secured & unsecured portfolios</li>
          <li>Process-led recovery cycles</li>
        </List>

        <HR />

        {/* BUSINESS INFORMATION */}
        <Sub>Business Information</Sub>

        <Label>Legal Name</Label>
        <Value>K SHYAM G MANAGEMENT</Value>

        <Label>GST Number</Label>
        <Value>09AXOPK0886D2Z5</Value>

        <Label>Entity Type</Label>
        <Value>Proprietorship</Value>

        <Label>Registration Type</Label>
        <Value>Regular</Value>

        <Label>Address</Label>
        <Value>
          1385 Tulsi Vihar, Dadri
          <br />
          Gautambuddha Nagar
          <br />
          Uttar Pradesh – 203207
        </Value>

        <Label>Nature of Business</Label>
        <Value>Supplier of Services, Recipient of Goods or Services</Value>

        <Label>Registration Date</Label>
        <Value>24/10/2019</Value>

        <HR />

        {/* CONTACT */}
        <Sub>Contact</Sub>

        <Label>Email</Label>
        <Value>Ksgm012020@gmail.com</Value>

        <Label>Office</Label>
        <Value>Dadri, Gautam Buddha Nagar, Uttar Pradesh</Value>
      </Card>
    </Section>
  );
}
